module.exports = __webpack_public_path__ + "static/media/cargo-thumbnail.52db10e6.svg";